import MultiSelect from '@/components/controls/multi-select';
import SelectControl from '@/components/controls/select-control';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Form } from '@/components/ui/form';
import { Download, FileText } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useDialog from './hooks/useDialog';
import { cn } from '@/lib/utils.ts';

type Props = {
  layoutOpen?: boolean;
};

export const ReportsDialog: FC<Props> = ({ layoutOpen }) => {
  const { t } = useTranslation();
  const {
    open,
    form,
    region,
    actions,
    setOpen,
    onSubmit,
    district,
    selectFormat,
    plantsSelect,
    isRegionDisabled,
    isDistrictDisabled,
    reportsLoading,
    onPlantChange,
    onRegionChange,
  } = useDialog();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          className="bg-green-100 text-white"
          onClick={() => setOpen(true)}
        >
          <FileText /> {layoutOpen && t('reports')}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="min-w-[700px]"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{t('reports')}</DialogTitle>
        </DialogHeader>
        <div className="w-full flex items-center gap-4">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="w-full">
              <div className="flex gap-4">
                <SelectControl
                  className="w-[200px]"
                  control={form.control}
                  name="plant_id"
                  options={plantsSelect || []}
                  label={t('plant_type')}
                  onChange={onPlantChange}
                />
                <SelectControl
                  className="w-[200px]"
                  control={form.control}
                  name="region_id"
                  options={region ? region.map(selectFormat) : []}
                  label={t('district')}
                  disabled={isRegionDisabled}
                  onChange={onRegionChange}
                />
                <SelectControl
                  className="w-[200px]"
                  control={form.control}
                  name="district_id"
                  options={district ? district.map(selectFormat) : []}
                  label={t('city')}
                  disabled={isDistrictDisabled}
                  notRequired
                />
              </div>
              <div className="flex gap-4 justify-between items-end">
                <MultiSelect
                  notRequired
                  className={cn(
                    'w-[400px]',
                    form.watch('region_id') && form.watch('plant_id')
                      ? 'cursor-pointer'
                      : 'pointer-events-none',
                  )}
                  label={t('events')}
                  name="action_id"
                  control={form.control}
                  options={actions}
                />
                <Button
                  type="submit"
                  isLoading={reportsLoading}
                  icon={<Download className="w-5 h-5" />}
                >
                  {t('download')}
                </Button>
              </div>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
};
